import { FC, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ErrorBoundary } from 'common/components';
import { MAIN_ROUTES } from 'common/config/routes.config';

import Login from 'modules/auth/pages/login/Login';
import Unauthorized from 'modules/auth/pages/unauthorized';

import './GuestLayout.scss';

const GuestLayout: FC = () => {
    return (
        <>
            <main className="app-guest-layout">
                <Suspense
                    fallback={
                        <>
                            <div>Fallback</div>
                        </>
                    }>
                    <ErrorBoundary>
                        <Routes>
                            <Route path={MAIN_ROUTES.UNAUTHORIZED} element={<Unauthorized />} />
                            <Route path={MAIN_ROUTES.DEFAULT} element={<Login />} />
                            <Route path={MAIN_ROUTES.WILD} element={<Login />} />
                        </Routes>
                    </ErrorBoundary>
                </Suspense>
            </main>
        </>
    );
};

export default GuestLayout;
